import React, { useEffect, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { checkEntityBeforeDelete } from '../../modules/config';
import Modal from '../elements/Modal';
import { Info } from '@mui/icons-material';

const EntityDeleteConfirmation = ({
  show,
  type,
  handleClose,
  handleConfirm,
  entityToDelete,
}) => {
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const checkData = async () => {
      setLoading(true);
      try {
        const response = await checkEntityBeforeDelete(entityToDelete, type)
        if (response && response?.schema_using_this_entity) {
          setResponseData(response.schema_using_this_entity);
          return;
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    if (show && entityToDelete && type !== 'AUTOMATION_FIELDS') {
      checkData();
    }
  }, [show]);

  const handleConfirmClose = () => {
    handleClose();
    setResponseData([]);
  };

  return (
    <Modal
      open={show}
      width="sm"
      handleClose={handleConfirmClose}
      modalTitle="Confirm"
      action={() => <>
        {responseData && responseData.length === 0 && <Button
          variant="danger"
          onClick={handleConfirm}
          title="Confirm">
          Confirm
        </Button>}
        <Button
          variant="outline-secondary"
          onClick={handleConfirmClose}
          title="Cancel">
          Cancel
        </Button>
      </>}>

      <>
        {loading ? (
          <p className="text-center"> Verifying...</p>
        ) : responseData && responseData.length > 0 ? (
          <>
            <p className="mb-2">This entity can not be deleted as</p>
            <Alert variant="warning">
              {responseData?.map((data, index) => (
                <p key={index} className={responseData.length > 1 ? 'mb-1' : 'mb-0'}>
                  <Info sx={{ color: '#664d03' }} size="16" /> {data.message}
                </p>
              ))}
            </Alert>
          </>
        ) : (
          <p>Are you sure you want to delete this?</p>
        )}
      </>
    </Modal>
  );
};

export default EntityDeleteConfirmation;
